import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonWrapper = styled.div`
  width: 100%;
  position: relative;
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  animation: ${shimmer} 1s linear infinite;
  border-radius: 8px;
  overflow: hidden;

  /* Mobile - altura menor */
  height: 300px;
  background-size: 800px 300px;

  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 500px;
    background-size: 850px 500px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    height: 300px;
    background-size: 800px 300px;
  }
`;

const SkeletonImage = styled.div`
  width: 100%;
  height: 100%;
  background: #e1e4e8;
  border-radius: 8px;
`;


const DesktopOnlyElements = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }
`;

const SkeletonBullets = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
`;

const SkeletonBullet = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
`;

const SkeletonNavButton = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  
  &.left {
    left: 20px;
  }
  
  &.right {
    right: 20px;
  }
`;

const PhotoCarouselSkeleton: React.FC = () => {
  return (
    <SkeletonWrapper>
      <SkeletonImage />
      
      <DesktopOnlyElements>
        <SkeletonNavButton className="left" />
        <SkeletonNavButton className="right" />
        <SkeletonBullets>
          {[...Array(5)].map((_, index) => (
            <SkeletonBullet key={index} />
          ))}
        </SkeletonBullets>
      </DesktopOnlyElements>
    </SkeletonWrapper>
  );
};

export default PhotoCarouselSkeleton;

